import { Lang } from './Lang'
import { RightMenu } from './RightMenu'

export const Comopnent = { RightMenu, Lang }
